import React, { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Loader from "../../components/Loader";
import { apiFetch } from "../../utils/api";
import useCalendarioStore from "../../store/calendarioStore";

const ReservacionesPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [datos, setDatos] = useState([])
  const [error, setError] = useState("")
  const [selectedReservacion, setSelectedReservacion] = useState(null);
  const [chatOpen, setChatOpen] = useState(false);
  const [chatLoading, setChatLoading] = useState(false);
  const [chatSending, setChatSending] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [chatText, setChatText] = useState("");
  const { cargarChatPartida, enviarChatPartida } = useCalendarioStore();

  const mapReservacion = (item) => ({
    ...item,
    estadoReserva: item.approvalStatus === "approved" ? "Aprobada" : item.approvalStatus === "pending" ? "Por aprobar" : item.approvalStatus || item.status,
    jugadoresTexto: `${Array.isArray(item.jugadores) ? item.jugadores.length : 0} / ${item.limiteJugadores || 0}`,
  });

  const nombreJugador = (jugador) => {
    if (!jugador) return "No especificado";
    return `${jugador.nombre || ""} ${jugador.apellido || ""}`.trim() || jugador.name || "Jugador sin nombre";
  };

  const fechaHora = (value) => {
    if (!value) return "No especificada";
    return new Date(value).toLocaleString("es-MX", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const abrirChatStaff = async (reservacion) => {
    setSelectedReservacion(reservacion);
    setChatOpen(true);
    setChatLoading(true);
    const response = await cargarChatPartida(reservacion.id);
    if (response.status) {
      setChatMessages(Array.isArray(response.data) ? response.data : []);
    } else {
      alert(response.message || "No se pudo cargar el chat de la partida.");
    }
    setChatLoading(false);
  };

  const enviarMensajeStaff = async () => {
    const text = chatText.trim();
    if (!selectedReservacion?.id || !text || chatSending) return;
    setChatSending(true);
    const response = await enviarChatPartida(selectedReservacion.id, text);
    if (response.status) {
      setChatText("");
      const reload = await cargarChatPartida(selectedReservacion.id);
      setChatMessages(Array.isArray(reload.data) ? reload.data : []);
    } else {
      alert(response.message || "No se pudo enviar el mensaje.");
    }
    setChatSending(false);
  };

  const cargarDatos = async () => {
    setIsLoading(true);
    setError("");
    try {
      const data = await apiFetch("/api/matches/reservations",{
        method: "GET",
      });
      console.log(data);
      if(data.status){
        setDatos(Array.isArray(data.data) ? data.data.map(mapReservacion) : []);
      } else {
        setDatos([]);
        setError(data.message || "No se pudieron cargar las reservaciones.");
      }
    } catch (error) {
      console.error('Error:', error);
      setDatos([]);
      setError(error.message || "No se pudieron cargar las reservaciones.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);

  return (
    <>
      <MasterLayout>
        { isLoading ? <Loader /> : (
          <>
            { error && (
              <div className="alert alert-warning" role="alert">
                {error}
              </div>
            )}
            <div className="card basic-data-table">
              <div className="card-header">
                <h5 className="mb-0">Reservaciones</h5>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table bordered-table mb-0">
                    <thead>
                      <tr>
                        <th>Nombre</th>
                        <th>Sucursal</th>
                        <th>Cancha</th>
                        <th>Fecha</th>
                        <th>Jugadores</th>
                        <th>Estado</th>
                        <th className="text-end">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {datos.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="text-center text-muted py-4">No hay registros disponibles</td>
                        </tr>
                      ) : datos.map((reservacion) => (
                        <tr key={reservacion.id}>
                          <td>
                            <div className="fw-semibold">{reservacion.titulo || "Reservación"}</div>
                            <div className="text-muted small">{reservacion.id}</div>
                          </td>
                          <td>{reservacion.branch?.nombre || reservacion.sucursal?.nombre || "No especificada"}</td>
                          <td>{reservacion.court?.nombre || reservacion.cancha?.nombre || "No especificada"}</td>
                          <td>{fechaHora(reservacion.fecha)}</td>
                          <td>{reservacion.jugadoresTexto}</td>
                          <td>
                            <span className={`badge ${reservacion.approvalStatus === "approved" ? "bg-success" : reservacion.approvalStatus === "pending" ? "bg-warning text-dark" : "bg-secondary"}`}>
                              {reservacion.estadoReserva}
                            </span>
                          </td>
                          <td className="text-end">
                            <div className="d-flex justify-content-end gap-2">
                              <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setSelectedReservacion(reservacion)}>
                                Ver detalle
                              </button>
                              <button type="button" className="btn btn-sm btn-outline-dark" onClick={() => abrirChatStaff(reservacion)}>
                                Chat staff
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        )}
      </MasterLayout>
      {selectedReservacion && !chatOpen && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content radius-16 bg-base">
              <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0 d-flex justify-content-between align-items-center">
                <h5 className="modal-title fs-5 mb-0">Detalle de reservación</h5>
                <button type="button" className="btn-close" onClick={() => setSelectedReservacion(null)} aria-label="Close" style={{ border: 'none', background: 'transparent', fontSize: '20px' }}>&times;</button>
              </div>
              <div className="modal-body p-24">
                <div className="row gy-3">
                  <div className="col-md-6"><span className="fw-bold d-block">Nombre</span>{selectedReservacion.titulo || "Reservación"}</div>
                  <div className="col-md-6"><span className="fw-bold d-block">Estado</span>{selectedReservacion.estadoReserva}</div>
                  <div className="col-md-6"><span className="fw-bold d-block">Sucursal</span>{selectedReservacion.branch?.nombre || selectedReservacion.sucursal?.nombre || "No especificada"}</div>
                  <div className="col-md-6"><span className="fw-bold d-block">Cancha</span>{selectedReservacion.court?.nombre || selectedReservacion.cancha?.nombre || "No especificada"}</div>
                  <div className="col-md-6"><span className="fw-bold d-block">Fecha y hora</span>{fechaHora(selectedReservacion.fecha)}</div>
                  <div className="col-md-6"><span className="fw-bold d-block">Duración</span>{selectedReservacion.duracion || 0} min</div>
                  <div className="col-md-6"><span className="fw-bold d-block">Tipo</span>{selectedReservacion.visibility || selectedReservacion.matchType || "No especificado"}</div>
                  <div className="col-md-6"><span className="fw-bold d-block">Jugadores</span>{selectedReservacion.jugadoresTexto}</div>
                </div>

                <hr />

                <div className="mb-3">
                  <span className="fw-bold d-block mb-2">Responsable</span>
                  {selectedReservacion.creador ? (
                    <div className="border rounded px-3 py-2">
                      <div className="fw-semibold">{nombreJugador(selectedReservacion.creador)}</div>
                      {[selectedReservacion.creador.email, selectedReservacion.creador.telefono].filter(Boolean).length > 0 && (
                        <div className="text-muted small">{[selectedReservacion.creador.email, selectedReservacion.creador.telefono].filter(Boolean).join(" · ")}</div>
                      )}
                    </div>
                  ) : (
                    <span className="text-muted">No especificado</span>
                  )}
                </div>

                <div>
                  <span className="fw-bold d-block mb-2">Jugadores unidos</span>
                  {Array.isArray(selectedReservacion.jugadores) && selectedReservacion.jugadores.length > 0 ? (
                    <div className="d-flex flex-column gap-2">
                      {selectedReservacion.jugadores.map((jugador, index) => (
                        <div key={jugador.userId || jugador.id || index} className="border rounded px-3 py-2 d-flex justify-content-between align-items-center">
                          <div>
                            <div className="fw-semibold">{nombreJugador(jugador)}</div>
                            {[jugador.email, jugador.telefono].filter(Boolean).length > 0 && (
                              <div className="text-muted small">{[jugador.email, jugador.telefono].filter(Boolean).join(" · ")}</div>
                            )}
                          </div>
                          {selectedReservacion.creador?.id && jugador.userId === selectedReservacion.creador.id && (
                            <span className="badge bg-primary">Creador</span>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <span className="text-muted">No hay jugadores unidos.</span>
                  )}
                </div>
              </div>
              <div className="modal-footer border border-bottom-0 border-start-0 border-end-0 py-16 px-24">
                <button type="button" className="btn btn-outline-dark" onClick={() => abrirChatStaff(selectedReservacion)}>Chat staff</button>
                <button type="button" className="btn btn-secondary" onClick={() => setSelectedReservacion(null)}>Cerrar</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {chatOpen && selectedReservacion && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1060 }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content radius-16 bg-base">
              <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0 d-flex justify-content-between align-items-center">
                <div>
                  <h5 className="modal-title fs-5 mb-0">Chat de partida</h5>
                  <div className="text-muted small">Vista staff · {selectedReservacion.court?.nombre || "Cancha"} · {fechaHora(selectedReservacion.fecha)}</div>
                </div>
                <button type="button" className="btn-close" onClick={() => setChatOpen(false)} aria-label="Close" style={{ border: 'none', background: 'transparent', fontSize: '20px' }}>&times;</button>
              </div>
              <div className="modal-body p-24">
                <div className="border rounded p-3" style={{ height: 320, overflowY: "auto", background: "#f8fafc" }}>
                  {chatLoading ? (
                    <div className="text-center text-muted py-5">Cargando chat...</div>
                  ) : chatMessages.length === 0 ? (
                    <div className="text-center text-muted py-5">Aun no hay mensajes en esta partida.</div>
                  ) : (
                    <div className="d-flex flex-column gap-2">
                      {chatMessages.map((message) => {
                        const name = `${message.user?.nombre || ""} ${message.user?.apellido || ""}`.trim() || "Usuario";
                        return (
                          <div key={message.id} className="bg-white border rounded px-3 py-2">
                            <div className="d-flex justify-content-between gap-2">
                              <span className="fw-semibold">{name}</span>
                              <span className="text-muted small">{message.createdAt ? new Date(message.createdAt).toLocaleString("es-MX") : ""}</span>
                            </div>
                            <div className="mt-1">{message.text}</div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
                <div className="mt-3">
                  <label className="form-label fw-semibold">Mensaje de staff</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    maxLength={1000}
                    value={chatText}
                    onChange={(event) => setChatText(event.target.value)}
                    placeholder="Escribe una nota breve para los participantes..."
                  />
                </div>
              </div>
              <div className="modal-footer border border-bottom-0 border-start-0 border-end-0 py-16 px-24">
                <button type="button" className="btn btn-secondary" onClick={() => setChatOpen(false)}>Cerrar</button>
                <button type="button" className="btn btn-primary" onClick={enviarMensajeStaff} disabled={chatSending || !chatText.trim()}>
                  {chatSending ? "Enviando..." : "Enviar mensaje"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReservacionesPage;
